import React from 'react';

import ImageNodeContainer from './ImageNodeContainer';
import MaskNodeContainer from './MaskNodeContainer';
import BetterTextNodeContainer from './BetterTextNodeContainer';

import type { Dimension, Orientation } from 'types/common_types';
import type { NodeAPIData } from 'types/catalog_types';

export type NodeProps = {
  canvasId: string;
  node: NodeAPIData;
  canvasDimensions: Dimension;
  canvasRotation: { rotation: number; userRotated: boolean };
  isCustomProduct: boolean;
  canvasRotationAllowed: boolean;
  canvasOrientation: Orientation;
  isMultiNodeProduct: boolean;
  setMaskImageLoaded: (set: { src: string; loaded: boolean }) => void;
};

function Node(props: NodeProps) {
  const {
    node,
    node: { node_type: nodeType },
  } = props;

  return (
    <div className="node">
      {nodeType === 1 && <ImageNodeContainer {...props} />}
      {nodeType === 2 && <MaskNodeContainer {...props} />}
      {nodeType === 3 && <BetterTextNodeContainer node={node} />}
    </div>
  );
}

export default Node;
